
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adminUser/create",
      function () {
        return require("private-next-pages/adminUser/create.tsx");
      }
    ]);
  